﻿// console.log('SIZE GUIDE FILE LOADED');

// Simple helpers to keep the refactor readable.
const $ = (selector, root = document) => root.querySelector(selector);
const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

// Centralized event names so custom events stay consistent.
const SIZE_GUIDE_EVENTS = {
    MODAL_OPENED: 'sizeGuideModal:opened',
    MODAL_CLOSED: 'sizeGuideModal:closed',
    TAB_CHANGED: 'sizeGuideTab:changed',
    DROPDOWN_PREVIEW: 'sizeGuideDropdown:preview',
    DROPDOWN_SELECTED: 'sizeGuideDropdown:selected',
    UNIT_CHANGED: 'sizeGuideUnit:changed',
    SIZE_CHANGED: 'sizeGuideSize:changed',
    MEASUREMENTS_UPDATED: 'sizeGuideMeasurements:updated'
};

// Safe data parsing for the size guide JSON.
const sizeGuideButton = $('.size-guide');
const rawData = sizeGuideButton?.getAttribute('data-size-guide');
let sizeGuideData = null;
try {
    sizeGuideData = rawData ? JSON.parse(rawData) : null;
} catch (err) {
    // console.warn('Invalid size guide JSON:', err);
}
// console.log('Size Guide Data:', sizeGuideData);

// Dispatch helper with detail payload to keep events uniform.
function emit(target, name, detail = {}) {
    if (!target) return;
    target.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
}

// return;


/* Start snippets\product-size-guide.liquid JS */
function sizeGuideSetup() {
    const modal = document.getElementById('size-guide-modal');
    if (!modal) return;

    // Prevent duplicate listener bindings on repeated setup calls (e.g. variant:change).
    if (!modal.dataset.sizeGuideInitialized) {
        modal.dataset.sizeGuideInitialized = 'true';

        // Open modal
        function openModal(openBtn) {
            modal.style.display = 'flex';
            setTimeout(() => modal.classList.add('show'), 10);
            openBtn.setAttribute('aria-expanded', 'true');
            document.body.classList.add('modal-open'); // <-- Add class to body

            // Trigger Custom Event for Modal Opened
            emit(modal, SIZE_GUIDE_EVENTS.MODAL_OPENED, { openBtn, modal });
        }

        // Close modal
        function closeModal() {
            modal.classList.remove('show');
            openBtns.forEach((openBtn) => {
                openBtn.setAttribute('aria-expanded', 'false');
            });
            document.body.classList.remove('modal-open'); // <-- Remove class from body
            modal.addEventListener('transitionend', function handler() {
                modal.style.display = 'none';
                modal.removeEventListener('transitionend', handler);

                // Notify listeners that the modal finished closing.
                emit(modal, SIZE_GUIDE_EVENTS.MODAL_CLOSED, { modal });
            });
        }

        // Event listeners
        const openBtns = $$('.size-guide');
        openBtns.forEach((openBtn) => {
            openBtn.addEventListener('click', openModal.bind(null, openBtn));
        });

        const closeBtns = $$('.modal .close');
        closeBtns.forEach((closeBtn) => {
            closeBtn.addEventListener('click', closeModal);
        });

        window.addEventListener('click', (e) => {
            if (e.target === modal) closeModal();
        });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('show')) closeModal();
        });

        // Rashid Size Guide Modal Tab
        $$('.tab-btn').forEach((btn) => {
            btn.addEventListener('click', () => {
                $$('.tab-btn').forEach((mainButton) => {
                    mainButton.classList.remove('active');
                });
                btn.classList.add('active');
                $$('.tab-description').forEach((tabContent) => {
                    tabContent.classList.remove('active');
                });
                document.getElementById(btn.dataset.tab)?.classList.add('active');

                // Broadcast the tab change for any future integrations.
                emit(modal, SIZE_GUIDE_EVENTS.TAB_CHANGED, { tabId: btn.dataset.tab });
            });
        });

        // Modal open hook to initialize tab functionality.
        modal.addEventListener(SIZE_GUIDE_EVENTS.MODAL_OPENED, (e) => {
            // console.log('Size Guide Modal Opened:', e.detail);

            const { modal, openBtn } = e.detail;

            sizeGuideTabOne(modal, openBtn);
            sizeGuideTabTwo(modal, openBtn);

            // You can access the open button and modal from e.detail.openBtn and e.detail.modal
        });
    }
}
/* End snippets\product-size-guide.liquid JS */

/* Start snippets\product-size-guide-tab-one.liquid JS */
function sizeGuideTabOne(modal, openBtn) {
    // Avoid re-binding listeners if the modal opens multiple times.
    if (modal.dataset.sizeGuideTabOneInitialized) return;
    modal.dataset.sizeGuideTabOneInitialized = 'true';

    const dropdown = modal.querySelector('.dropdown');
    if (!dropdown) return;

    // console.log('Dropdown Element:', dropdown);
    const btn = dropdown.querySelector('.dropdown-btn');
    // console.log('Dropdown Button:', btn);
    const btnText = btn?.querySelector('span'); // <span> target
    // console.log('Dropdown Button Text Span:', btnText);
    const list = dropdown.querySelector('.dropdown-list');
    // console.log('Dropdown List:', list);
    const items = list ? Array.from(list.querySelectorAll('li')) : [];
    // console.log('Dropdown List Items:', items);
    const dataDivs = modal.querySelectorAll('.country-data');
    // console.log('Country Data Divs:', dataDivs);

    let selectedCountry = btnText?.textContent || '';

    // Ensure hidden lists do not capture hover when closed.
    if (list) {
        list.style.pointerEvents = 'none';
    }

    function setDropdownOpen(isOpen) {
        if (!list) return;
        list.classList.toggle('showing', isOpen);
        dropdown.classList.toggle('open', isOpen);
        list.style.pointerEvents = isOpen ? 'auto' : 'none';
    }

    // CLICK — open dropdown
    btn?.addEventListener('click', (e) => {
        e.stopPropagation();
        const willOpen = !list?.classList.contains('showing');
        setDropdownOpen(willOpen);
    });

    // HOVER — active remove + fade text preview
    items.forEach((item) => {
        item.addEventListener('mouseenter', (e) => {
            e.stopPropagation();
            if (!list?.classList.contains('showing')) return;
            items.forEach((i) => i.classList.remove('active'));

            if (btnText) {
                btnText.classList.add('text-fade');
                setTimeout(() => {
                    btnText.textContent = item.dataset.country;
                    btnText.classList.remove('text-fade');
                }, 200);
            }

            // Custom event for hover preview (optional analytics/UX hooks).
            emit(modal, SIZE_GUIDE_EVENTS.DROPDOWN_PREVIEW, {
                country: item.dataset.country
            });
        });

        item.addEventListener('mouseleave', (e) => {
            e.stopPropagation();
            // restore active
            items.forEach((i) => {
                if (i.dataset.country === selectedCountry) {
                    i.classList.add('active');
                }
            });
        });
    });

    // CLICK — lock selected
    items.forEach((item) => {
        item.addEventListener('click', (e) => {
            e.stopPropagation();

            selectedCountry = item.dataset.country;
            if (btnText) btnText.textContent = selectedCountry;

            items.forEach((i) => i.classList.remove('active'));
            item.classList.add('active');

            dataDivs.forEach((div) => {
                div.style.display = div.dataset.country === selectedCountry ? 'block' : 'none';
            });

            setDropdownOpen(false);

            // Custom event for selection change.
            emit(modal, SIZE_GUIDE_EVENTS.DROPDOWN_SELECTED, {
                country: selectedCountry
            });
        });
    });

    // CLICK outside — close
    document.addEventListener('click', () => {
        setDropdownOpen(false);
    });

    // Default showing
    dataDivs.forEach((div) => {
        div.style.display = div.dataset.country === selectedCountry ? 'block' : 'none';
    });

    // Smooth scrollbar + drag-to-scroll wiring (idempotent per element).
    $$('.size-guide-scroll').forEach(function (el) {
        if (el.dataset.sizeGuideScrollInit) return;
        el.dataset.sizeGuideScrollInit = 'true';

        const scrollbar = Scrollbar.init(el, {
            damping: 0.05,
            alwaysShowTracks: true,
            continuousScrolling: true,
        });

        let isDown = false;
        let startX = 0;
        let startY = 0;
        let velocityX = 0;
        let velocityY = 0;
        let raf = null;

        const friction = 0.92;
        const minVelocity = 0.3;

        function momentum() {
            if (Math.abs(velocityX) > minVelocity || Math.abs(velocityY) > minVelocity) {
                scrollbar.scrollLeft -= velocityX;
                scrollbar.scrollTop -= velocityY;

                velocityX *= friction;
                velocityY *= friction;

                raf = requestAnimationFrame(momentum);
            }
        }

        el.addEventListener('mousedown', (e) => {
            isDown = true;
            startX = e.clientX;
            startY = e.clientY;
            velocityX = velocityY = 0;
            if (raf) cancelAnimationFrame(raf);
            el.classList.add('dragging');
        });

        window.addEventListener('mouseup', () => {
            if (!isDown) return;
            isDown = false;
            el.classList.remove('dragging');
            momentum();
        });

        el.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();

            const dx = e.clientX - startX;
            const dy = e.clientY - startY;

            scrollbar.scrollLeft -= dx;
            scrollbar.scrollTop -= dy;

            velocityX = dx;
            velocityY = dy;

            startX = e.clientX;
            startY = e.clientY;
        });
    });
}



/* End snippets\product-size-guide-tab-one.liquid JS */

/* Start snippets\product-size-guide-tab-two.liquid JS */
function sizeGuideTabTwo(modal, openBtn) {
    // Avoid re-binding listeners if the modal opens multiple times.
    if (modal.dataset.sizeGuideTabTwoInitialized) return;
    modal.dataset.sizeGuideTabTwoInitialized = 'true';

    /* -------------------------
     * Safari detection
     * ------------------------- */
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
        document.documentElement.classList.add('safari-browser');
    }

    const measurementData = {
        standard: {
            XS: { bust: '79–81', waist: '61–63', hip: '87–89' },
            S: { bust: '82–87', waist: '64–69', hip: '90–95' },
            M: { bust: '88–93', waist: '70–75', hip: '96–101' },
            L: { bust: '94–101', waist: '76–84', hip: '102–109' },
            XL: { bust: '102–111', waist: '85–94', hip: '110–119' }
        },

        it: {
            XS: { bust: '81–84', waist: '63–66', hip: '89–91' },
            S: { bust: '84–86', waist: '66–69', hip: '91–94' },
            M: { bust: '89–91', waist: '71–74', hip: '97–99' },
            L: { bust: '94–97', waist: '76–79', hip: '102–104' },
            XL: { bust: '102–104', waist: '81–84', hip: '107–109' }
        },

        bottoms: {
            XS: { waist: '56–58' },
            S: { waist: '61–68' },
            M: { waist: '71–79' },
            L: { waist: '81–89' },
            XL: { waist: '91' }
        },

        zimmermann_tops_system: {
            XS: { bust: '80', waist: '24' },
            S: { bust: '84', waist: '25–26' },
            M: { bust: '89', waist: '27–28' },
            L: { bust: '94', waist: '29–30' },
            XL: { bust: '99', waist: '31–32' },
            XXL: { bust: '104', waist: '33–34' }
        },

        zimmermann_bottom_system: {
            XS: { waist: '24' },
            S: { waist: '25–26' },
            M: { waist: '27–28' },
            L: { waist: '29–30' },
            XL: { waist: '31–32' },
            XXL: { waist: '33–34' }
        },

        versace_swimwear_top_system: {
            XS: { bust: '85–87', underbust: '69–72', waist: '67–69', hip: '91–93', shoulders: '39' },
            S: { bust: '89–91', underbust: '73–77', waist: '71–73', hip: '95–97', shoulders: '40' },
            M: { bust: '94–96', underbust: '78–82', waist: '75–77', hip: '99–101', shoulders: '41.4' },
            L: { bust: '99–101', underbust: '83–87', waist: '79–81', hip: '103–105', shoulders: '42.4' },
            XL: { bust: '104–106', underbust: '88–92', waist: '83–85', hip: '107–109', shoulders: '43.4' }
        },

        versace_swimwear_bottom_system: {
            XS: { waist: '67–69', hip: '91–93' },
            S: { waist: '71–73', hip: '95–97' },
            M: { waist: '75–77', hip: '99–101' },
            L: { waist: '79–81', hip: '103–105' },
            XL: { waist: '83–85', hip: '107–109' }
        },

        shoes: {
            XS: { foot_length: '22.0–23.0' },
            S: { foot_length: '23.5–24.3' },
            M: { foot_length: '24.6–25.7' },
            L: { foot_length: '26.0–27.0' },
            XL: { foot_length: '27.3–27.6' }
        },

        belt: {
            XS: { size: '70', waist: '63–68' },
            S: { size: '75–80', waist: '68–78' },
            M: { size: '85–90', waist: '78–88' },
            L: { size: '95–100', waist: '88–98' },
            XL: { size: '105', waist: '98–103' }
        },

        ring: {
            XS: { diameter: '14.9', circumference: '46.8' },
            S: { diameter: '15.7', circumference: '49.3' },
            M: { diameter: '17.3', circumference: '54.4' },
            L: { diameter: '18.1', circumference: '57.0' },
            XL: { diameter: '18.9', circumference: '59.5' }
        }

    };

    const sizeMap = {
        standard: { XS: 'XS', S: 'S', M: 'M', L: 'L', XL: 'XL' },
        it: { XS: 'XS', S: 'S', M: 'M', L: 'L', XL: 'XL' },
        bottoms: { XS: 'XS', S: 'S', M: 'M', L: 'L', XL: 'XL' },
        zimmermann_tops_system: { "0P": "XS", "0": "S", "1": "M", "2": "L", "3": "XL", "4": "XXL" },
        zimmermann_bottom_system: { "0P": "XS", "0": "S", "1": "M", "2": "L", "3": "XL", "4": "XXL" },
        versace_swimwear_top_system: { XS: 'XS', S: 'S', M: 'M', L: 'L', XL: 'XL' },
        versace_swimwear_bottom_system: { XS: 'XS', S: 'S', M: 'M', L: 'L', XL: 'XL' },
        shoes: { XS: 'XS', S: 'S', M: 'M', L: 'L', XL: 'XL' },
        belt: { XS: 'XS', S: 'S', M: 'M', L: 'L', XL: 'XL' },
        ring: { XS: 'XS', S: 'S', M: 'M', L: 'L', XL: 'XL' }
    };

    let currentUnit = 'inch';
    let currentSize = document.querySelector("input[name='size']:checked")?.value || 'XS';

    function cmRangeToInch(range) {
        if (!range) return '';

        // Support both real en-dash and legacy encoded dash.
        const parts = String(range).split(/[––]/).map(part => part.trim()).filter(Boolean);
        if (parts.length === 2) {
            const [min, max] = parts.map(Number);
            const minInch = (min / 2.54).toFixed(1);
            const maxInch = (max / 2.54).toFixed(1);

            return `${minInch} – ${maxInch}`;
        }

        const val = Number(range);
        if (!isNaN(val)) {
            return (val / 2.54).toFixed(1);
        }

        return range;
    }

    const rowsContainer = document.getElementById('measurementRows');

    function prettyLabel(key) {
        return key
            .replace(/_/g, ' ')
            .replace(/\b\w/g, c => c.toUpperCase());
    }

    function renderRows(values) {
        rowsContainer.innerHTML = '';

        Object.keys(values).forEach(key => {
            const row = document.createElement('div');
            row.innerHTML = `
      <span>${prettyLabel(key)}</span>
      <span class="fade-animate" data-key="${key}"></span>
    `;
            rowsContainer.appendChild(row);
        });
    }

    function getMeasurementSystem() {
        const sizeSystem = window.SIZE_SYSTEM || 'standard';
        const clothingSystem = window.CLOTHING_SYSTEM || 'one';

        // Brand Systems 
        if (window.ZIMMERMANN_TOPS_SYSTEM) return 'zimmermann_tops_system';
        if (window.ZIMMERMANN_BOTTOM_SYSTEM) return 'zimmermann_bottom_system';
        if (window.MONCLER_CLOTHING_SIZE_SYSTEM) return 'standard';                             // Moncler uses standard measurements, because in figma data is not provided so we return 'standard' to use the standard size mapping
        if (window.VERSACE_SWIMWEAR_TOP_SYSTEM) return 'versace_swimwear_top_system';
        if (window.VERSACE_SWIMWEAR_BOTTOM_SYSTEM) return 'versace_swimwear_bottom_system';

        // Category systems AFTER brand systems, because some categories can have brand-specific systems (e.g. Zimmermann clothing)
        if (window.BOTTOM_SYSTEM) return 'bottoms';
        if (window.SHOES_SYSTEM) return 'shoes';
        if (window.BELT_SYSTEM) return 'belt';
        if (window.RING_SYSTEM) return 'ring';

        if (sizeSystem === 'it' && clothingSystem === 'two') {
            return 'it';
        }

        return 'standard';
    }

    function fadeUpdate(el, newValue) {
        el.classList.add('fade-out');

        setTimeout(() => {
            el.innerText = newValue;
            el.classList.remove('fade-out');
        }, 250);
    }

    function updateValues() {
        const system = getMeasurementSystem();
        const mappedSize = sizeMap[system]?.[currentSize];
        if (!mappedSize) return;

        const values = measurementData[system][mappedSize];
        if (!values) return;

        renderRows(values);

        Object.keys(values).forEach(key => {
            const el = document.querySelector(`[data-key="${key}"]`);
            if (!el) return;

            const val = currentUnit === 'cm'
                ? String(values[key]).replace(/[––]/g, ' – ') + ' cm'
                : cmRangeToInch(values[key]) + ' Inch';

            fadeUpdate(el, val);
        });

        // Broadcast current state so other scripts can react without tight coupling.
        emit(modal, SIZE_GUIDE_EVENTS.MEASUREMENTS_UPDATED, {
            system,
            unit: currentUnit,
            size: currentSize,
            values
        });
    }

    document.querySelectorAll("input[name='unit']").forEach((radio) => {
        radio.addEventListener('change', (e) => {
            currentUnit = e.target.value;
            updateValues();

            // Custom event hook for unit changes.
            emit(modal, SIZE_GUIDE_EVENTS.UNIT_CHANGED, { unit: currentUnit });
        });
    });

    document.querySelectorAll("input[name='size']").forEach((radio) => {
        radio.addEventListener('change', (e) => {
            currentSize = e.target.value;
            updateValues();

            // Custom event hook for size changes.
            emit(modal, SIZE_GUIDE_EVENTS.SIZE_CHANGED, { size: currentSize });
        });
    });

    // document.addEventListener('DOMContentLoaded', updateValues);

    updateValues();
}
/* End snippets\product-size-guide-tab-two.liquid JS */



const productForms = document.querySelectorAll(".shopify-product-form");

productForms.forEach((form) => {
    form.addEventListener("variant:change", (event) => {
        // const previousVariant = event.detail.previousVariant;    
        sizeGuideSetup();

    });
});


document.addEventListener('DOMContentLoaded', sizeGuideSetup);

